<h3 class="font-weight-bold">Hotel Details</h3>

<div class="table-responsive" *ngIf="dashboardFacade.vm$ | async as vm">
    <p>{{ vm.hotelDetail.hotel.name }}</p>
</div>